import React, { useEffect, useCallback, useState, memo } from 'react';
import { postIssueVirAcc } from '@store/actions/appListAction';
import { useDispatch } from 'react-redux';

import SatButton from '@components/common/satUI/SatButton';
import { format } from 'date-fns';

// 가상 계좌 재 발급 팝업
const PostIssueVirAccPopup = props => {
  const { policyNo, ownerName, virtAccCreateTime, closeModal } = props;

  const [apiResultMsg, setApiResultMsg] = useState('');

  const dispatch = useDispatch();

  useEffect(() => {
    const virtAccCreateDate = virtAccCreateTime?.slice(0, 8);
    const today = format(new Date(), 'yyyyMMdd');

    if (virtAccCreateDate === today) {
      setApiResultMsg(
        '당일 1회 이상 가상계좌 재 발급 불가합니다. 기 발급된 가상계좌로 입금을 진행 부탁합니다.',
      );
    } else {
      handlePostIssueVirAcc(policyNo, ownerName);
    }
  }, []);

  //가상 계좌 재발급
  const handlePostIssueVirAcc = useCallback(
    (policyNo, ownerName) =>
      dispatch(
        postIssueVirAcc({
          policyNo: policyNo,
          callback: (status, data) => {
            if (status === 200) {
              setApiResultMsg(
                `계약자 ${ownerName}님에게 가상계좌 재발급안내가 되었습니다. 당일까지 해당 계좌로 입금될 수 있도록 안내 부탁드립니다.`,
              );
            } else {
              setApiResultMsg(data.detail || '실패 하였습니다.');
            }
          },
        }),
      ),
    [],
  );
  // 팝업 닫기
  const closePopup = () => {
    closeModal({
      visible: false,
    });
  };

  const contRender = useCallback(apiResultMsg => {
    return <p className="layer-text text-center">{apiResultMsg}</p>;
  }, []);

  return (
    <>
      <div className="cont">{contRender(apiResultMsg)}</div>
      <div className="box-btns-center">
        <SatButton
          label="확인"
          styleClass="btn-s blue btn-wide"
          onClick={() => closePopup()}
        />
      </div>
    </>
  );
};

export default memo(PostIssueVirAccPopup);
